__webpack_require__.p = "/Training-ISM/";